// default value for event handler, empty function
// eslint-disable-next-line import/prefer-default-export
export const noop = (): void => {};
